export default {
  TITLE: 'My Messages',
  SUMMARY: 'Messages allow your company to communicate important information to you.',
  PUBLISHED_BY: 'Published by {{ name }} on {{ date }}',
  POSTED: 'Posted',
  IMPORTANT: 'Important',
  NEW: 'New',
  NO_MESSAGES: 'No messages to display',
  SHOWN_TO: `Shown to`,
  SHOWN_TO_EVERONE: `Shown to everybody`,
  NO_CONTENT: `No bulletin content`,
  SHOW: `Show`,
  HIDE: `Hide`,
  SHOW_HIDDEN_MESSAGES: `Show hidden messages`,
  HIDE_HIDDEN_MESSAGES: `Hide hidden messages`
}
